import script from "./Location.vue?vue&type=script&setup=true&lang=js"
export * from "./Location.vue?vue&type=script&setup=true&lang=js"

import "./Location.vue?vue&type=style&index=0&id=52da655b&lang=css"

const __exports__ = script;

export default __exports__